import { REQUEST_SERVICE_RECOMMANDATION_BASIC, FETCH_SERVICE_RECOMMANDATION_BASIC } from '../actions/Types'

const recommanderReducer = (state={loading: false, data: []}, action) => {
    switch (action.type){
        case REQUEST_SERVICE_RECOMMANDATION_BASIC:
            return {loading: true, data: []}
        case FETCH_SERVICE_RECOMMANDATION_BASIC:
            return {loading: false, data: action.payload}
        default:
            return state
    }
}

export default recommanderReducer